<div>
    <div class="text-center">
        <mat-icon class="size">info</mat-icon>
    </div>
    <h2 mat-dialog-title class="title text-center">
        <b>{{data.title}}</b>
    </h2>
    <mat-dialog-content class="mat-typography text-capitalize">
        <h4>{{data.body}}</h4>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Salir</button>
    </mat-dialog-actions>
</div>